export default {
  gbp: {
    DELIVERY: 500,
    HOTEL: 500,
    RESTAURANT: 500,
    SPA: 500,
    BEAUTY_SALON: 500,
  },
  cad: {
    DELIVERY: 500,
    HOTEL: 500,
    RESTAURANT: 500,
    SPA: 500,
    BEAUTY_SALON: 500,
  },
  eur: {
    DELIVERY: 500,
    HOTEL: 500,
    RESTAURANT: 500,
    SPA: 500,
    BEAUTY_SALON: 500,
  },
  dkk: {
    DELIVERY: 5000,
    HOTEL: 5000,
    RESTAURANT: 5000,
    SPA: 5000,
    BEAUTY_SALON: 5000,
  },
  sar: {
    DELIVERY: 500,
    HOTEL: 500,
    RESTAURANT: 500,
    SPA: 500,
    BEAUTY_SALON: 500,
  },
  usd: {
    DELIVERY: 500,
    HOTEL: 500,
    RESTAURANT: 500,
    SPA: 500,
    BEAUTY_SALON: 500,
  },
  aed: {
    DELIVERY: 1000,
    HOTEL: 1000,
    RESTAURANT: 1000,
    SPA: 1000,
    BEAUTY_SALON: 1000,
  },
};
